import { connect } from 'react-redux'
import OwnInfo from '../../components/dashboard/ownInfo.component'

const mapStateToProps = (state) => {
  const { client, adminUser } = state
  const userType = client.user.data[5]
  const invoices = state.dashboard.invoices ? state.dashboard.invoices : []
  const lang = state.language.lang ? state.language.lang : []

  // counting due invoices
  const today = new Date(new Date().toDateString())
  let counter = 0
  let dueInvoicesSum = 0
  for (const obj of invoices) {
    const due_date = new Date(obj.due_date)
    if (
      (obj.status === 1 || obj.status === 3 || obj.status === 5) &&
      due_date.getTime() < today.getTime()
    ) {
      counter++
      dueInvoicesSum = dueInvoicesSum + obj.total_sum
    }
  }

  return {
    userTaxInfo: state.dashboard.userTaxInfo,
    userType,
    selectedUser: adminUser.selectedUser,
    due_invoices: counter,
    lang: lang,
    dueInvoicesSum: dueInvoicesSum
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

const OwnInfoContainer = connect(mapStateToProps, mapDispatchToProps)(OwnInfo)

export default OwnInfoContainer
